import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button, Grid, Icon, Dropdown } from 'semantic-ui-react';
import { Modal, ModulesFilter, SelectionsModal, PRODUCT_PERMISSIONS, USER_PERMISSIONS, CardData, CardDataItem } from 'dyl-components';

import { useSelector } from 'react-redux';
import MasterAccountForm from 'shared/MasterAccountForm';
import AddAccountModal from "../../../shared/modals/AddAccountModal";

import {
    KEY_CREATED_ON, KEY_ACCOUNT_TYPE, KEY_REACTIVATED_ON,
    KEY_CREATED_BY, KEY_OWNER, KEY_REACTIVATED_BY,
    KEY_LAST_MODIFIED, KEY_FUND_TYPE, KEY_ACCOUNT_STATUS,
    KEY_LAST_MODIFIED_BY, KEY_CUSTOMER_SINCE, KEY_ACTIONS, 
    KEY_CANCELED_ON, KEY_NAME, KEY_CANCELED_BY,KEY_CO_OWNER
} from './constants';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import RestrictedView from 'shared/RestrictedView';

const TYPES = [
    { id: 'master_account', name: 'Master Accounts', icon: 'fa-solid fa-buildings', width: '16%' , userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_VIEW},
    { id: 'business', name: 'Businesses', icon: 'fa-solid fa-building', userPermission: USER_PERMISSIONS.ACCOUNT_VIEW },
    { id: 'household', name: 'Households', icon: 'fa-solid fa-house-chimney-blank', userPermission: USER_PERMISSIONS.ACCOUNT_VIEW  },
    { id: 'customer', name: 'Customers', icon: 'fa-solid fa-users', userPermission: USER_PERMISSIONS.ACCOUNT_VIEW  },
];

const DROPDOWN = [
    { key: 0, value: 'master', text: 'New Master Account', icon: 'fa-solid fa-buildings', userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_ADD, productPermission: ''},
    { key: 1, value: 'account', text: 'New Account', icon: 'fa-solid fa-screen-users', userPermission: USER_PERMISSIONS.ACCOUNT_ADD, productPermission: PRODUCT_PERMISSIONS.RECORDS },
]
const AddModalContent = ({ activeContent, onClose, onDirtyChange}) => {
    const navigate = useNavigate();
    switch (activeContent) {
        case 'BusinessAccount':
            return <AddAccountModal
                account_type={'business'}
                onClose={onClose}
                refreshFromLinking={() => {
                    navigate(`/accounts?page=1`);
                }}
                onDirtyChange={onDirtyChange}
            />;
        case 'HouseholdAccount':
            return <AddAccountModal
                account_type={'household'}
                onClose={onClose}
                refreshFromLinking={() => {
                    navigate(`/accounts?page=1`);
                }}
                onDirtyChange={onDirtyChange}
            />;
        default:
            return null;
    }
}

export const AccountsToolbar = (({ search, onSearchSubmit, cancelFunction, onChangeSearch, isColumnHidden, onToggleColumn, onFilter, isDropDownOpen, setIsDropDownOpen }) => {
    const { isReadingAccounts, counts } = useSelector(state => ({
        isReadingAccounts: state.account.isReadingAccounts,
        counts: state.account.counts
    }));

    const [isFormDirty, setIsFormDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [activeContent, setActiveContent] = useState('selection');

    const modalCategories = [
        {
            selections: [
                { key: 'BusinessAccount', text: 'Business Account', icon: 'fa-solid fa-building' },
                { key: 'HouseholdAccount', text: 'Household Account', icon: 'fa-solid fa-house-chimney-blank' }
            ]
        }
    ];

    const [params] = useSearchParams();

    const navigate = useNavigate();

    const [filteredType, setFilteredType] = useState(params.get('filter'));

    const isFilterActive = (type) => {
        return filteredType === type;
    }

    const onFilterByType = (type) => {
        if (filteredType !== type) {
            setFilteredType(type);
            onFilter(null, { name: 'filter', value: type });
        } else {
            setFilteredType('');
            onFilter(null, { name: 'filter', value: '' });
        }
    }

    const getFilterValue = (type) => {
        switch (type) {
            case 'master_account':
                return counts.master_account_count;
            case 'business':
                return counts.business_count;
            case 'household':
                return counts.household_count;
            case 'customer':
                return counts.customer_count;
            default:
                return 0;
        }
    }

    const [linkAccountAction, setLinkAccountAction] = useState(null);

    const openLinkAccountModal = (action) => {
        setLinkAccountAction(action);
    }
    const closeAccountCreationModal = () => {
        setActiveContent('selection');
        setLinkAccountAction(null);
    }

    const isAccountCreationModalOpen = (action) => {
        return action === linkAccountAction;
    }

    const isDyl = useSelector(state => state.auth.dyl_employee);

    const COLUMN_ROWS = isDyl ? [
        [
            { value: KEY_CREATED_ON, label: "Created" },
            { value: KEY_ACCOUNT_TYPE, label: "Type" },
            { value: KEY_CANCELED_BY, label: "Canceled By" }
        ],
        [
            { value: KEY_CREATED_BY, label: "Created By" },
            { value: KEY_OWNER, label: "Owned By" },
            { value: KEY_CO_OWNER, label: "Co-Owned By" },
            
        ],
        [
            { value: KEY_LAST_MODIFIED, label: "Last Modified" },
            { value: KEY_FUND_TYPE, label: "Customer Category" },
            { value: KEY_REACTIVATED_BY, label: "Reactivated By" }
        ],
        [
            { value: KEY_LAST_MODIFIED_BY, label: "Last Modified By" },
            { value: KEY_CUSTOMER_SINCE, label: "Customer Since" },
            { value: KEY_ACCOUNT_STATUS, label: "Account Status" }
        ],
        [
            { value: KEY_NAME, label: "Account Name", isForcedChecked: true },
            { value: KEY_CANCELED_ON, label: "Canceled On" },
            { value: KEY_ACTIONS, label: "Actions" }
        ]
    ] : [
        [
            { value: KEY_CREATED_ON, label: "Created" },
            { value: KEY_ACCOUNT_TYPE, label: "Type" },
            { value: KEY_CANCELED_ON, label: "Canceled On" },
            
        ],
        [
            { value: KEY_CREATED_BY, label: "Created By" },
            { value: KEY_OWNER, label: "Owner" },
            { value: KEY_CANCELED_BY, label: "Canceled By" }
            
        ],
        [
            { value: KEY_LAST_MODIFIED, label: "Last Modified" },
            { value: KEY_ACCOUNT_STATUS, label: "Account Status" },
            { value: KEY_REACTIVATED_ON, label: "Reactivated On" }
            
        ],
        [
            { value: KEY_LAST_MODIFIED_BY, label: "Last Modified By" },
            { value: KEY_CUSTOMER_SINCE, label: "Customer Since" },
            { value: KEY_REACTIVATED_BY, label: "Reactivated By" }
        ],
        [
            { value: KEY_NAME, label: "Account Name", isForcedChecked: true },
            { value: KEY_ACTIONS, label: "Actions" },
            { value: KEY_REACTIVATED_ON, label: "Reactivated On" }
        ]
    ]
  
    return (
        <React.Fragment>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <div className='Accounts__info'>
                            {TYPES.map(type => (
                                <RestrictedView userPermission={type.userPermission} type="hidden">
                                    <div style={{ marginRight: '1em', width: type.width || '11%' }}>
                                        <CardData active={isFilterActive(type.id)} onClick={() => { onFilterByType(type.id); }}>
                                            <CardDataItem>
                                                <Icon style={{ margin: '0 5px' }} className={type.icon} /> <strong>{type.name}: </strong>&nbsp;<span className={`FilterValue${getFilterValue(type.id) === 0 ? '' : '--not-zero'}`}> {getFilterValue(type.id)} </span>
                                                {isFilterActive(type.id) &&
                                                    <Icon style={{ marginLeft: 10 }} className='fa-solid fa-circle-x' link onClick={() => onFilterByType(type.id)} />
                                                }
                                            </CardDataItem>
                                        </CardData>
                                    </div>
                                </RestrictedView>
                            ))}
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={5}>
                        <ModulesFilter
                            isLoading={isReadingAccounts}
                            search={search}
                            onSearchSubmit={onSearchSubmit}
                            cancelFunction={cancelFunction}
                            onChangeSearch={onChangeSearch}
                            columnRows={COLUMN_ROWS}
                            columnCount={3}
                            isColumnHidden={isColumnHidden}
                            onToggleColumn={onToggleColumn}
                            searchBarPlaceholder={"Search by Master Account Name, Account Name or Account ID"}
                        />
                    </Grid.Column>
                    <Grid.Column width={3} floated='right'>
                        <Dropdown
                            as={Button}
                            floated='right'
                            floating
                            pointing='top left'
                            color='primary'
                            text={<span><Icon name='plus' /> New Account</span>}
                            className='AddAccountButton'
                            value={linkAccountAction}
                            selectOnBlur={false}
                            onClick={()=>{
                                setIsDropDownOpen(!isDropDownOpen)
                            }}
                            open={isDropDownOpen}
                            onClose={()=>{
                                setIsDropDownOpen(!isDropDownOpen)
                            }}
                        >  
                            <Dropdown.Menu>
                                {DROPDOWN.map(item => (
                                    <RestrictedView type="hidden" userPermission={item.userPermission} productPermission={item.productPermission}>
                                        <Dropdown.Item onClick={() => { openLinkAccountModal(item.value) }}>
                                            <Icon className={item.icon} /> {item.text}
                                        </Dropdown.Item>
                                    </RestrictedView>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Modal open={isAccountCreationModalOpen('master')} onClose={() => {
                        isFormDirty
                            ? setIsConfirmationOpen(true)
                            : closeAccountCreationModal();
                    }}>
                <MasterAccountForm
                    close={closeAccountCreationModal}
                    refreshFromLinking={() => {
                        navigate(`/accounts?page=1`);
                    }}
                    onDirtyChange={(dirty) => setIsFormDirty(dirty)}
                />
            </Modal>
            <SelectionsModal
                contentModalSize={activeContent => {
                    if (activeContent === 'selection') {
                        return 'tiny';
                    }
                    return 'big';
                }}
                open={isAccountCreationModalOpen('account')}
                selectionHeader='Create Account'
                categories={modalCategories}
                ToRender={AddModalContent}
                hasCancel={false}
                hasFirstSelection={false}
                toRenderProps={{ onDirtyChange: (dirty) => setIsFormDirty(dirty) }}
                onClose={() => {
                    isFormDirty
                        ? setIsConfirmationOpen(true)
                        : closeAccountCreationModal();
                }}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
            />
              <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    closeAccountCreationModal()
                    setIsConfirmationOpen(false);
                    setIsFormDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </React.Fragment>
    )
})
